// Worklog exclusion configuration
// Form elements that should not appear in worklog display

export const WORKLOG_EXCLUSIONS = {
  checkboxTextPatterns: [
    'Referencing the markings on the ground, inform the excavator of the facility(s) that requires the onsite field meet.',
  ],
};
